module.exports = __webpack_public_path__ + "img/categories.749f52ae.svg";